const initialState = {
	loading: false,
	values: null,
	updating: false,
	error: null
};

/**
 * Reducer managing contingent.
 *
 * @name EquipmentReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		// TODO: remove when we use new style action everywhere
		return state;
	}

	return action.performEquipmentReducer(state);
};
